// extracted by mini-css-extract-plugin
export var collapsed = "ContentNodeCard-module--collapsed--vjGLH";
export var excerpt = "ContentNodeCard-module--excerpt--9LwoX";